import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http'
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonServicesService {
  sideBarHideShow = new BehaviorSubject<boolean>(true);
  workSpaceSetupName = new BehaviorSubject<any>('workspace_setup');
  constructor(private http: HttpClient) { }

  setWorkspaceSetupName(name: any) {
    this.workSpaceSetupName.next(name);
  }

  getWorkspaceSetupName() {
    return this.workSpaceSetupName as Observable<any>;
  }

  httpPostServiceForContentTypeUrlencoded(Url,Payload):Observable<any>{
    let body=new URLSearchParams();
    body.set("Username",Payload.Username);
    body.set("Password",Payload.Password);

    let _headers=new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
    });
    return this.http.post(Url,body,{headers:_headers});
  }
  httpCommonPutService(Url, Payload): Observable<any> {
    return this.http.put(Url, Payload);
  }
  httpPostServiceForContentTypeFormData(Url,Payload):Observable<any>{
    let  body = new URLSearchParams();
    body.append("userid",Payload.userid);
    body.append("emailid",Payload.emailid);

    let _headers=new HttpHeaders({
      'Content-Type':'application/x-www-form-urlencoded'
    });
    return this.http.post(Url,body,{headers:_headers});
  }

  httpPostServiceForRedirected(Url, Payload): Observable<any> {
    return this.http.post(Url, Payload, { responseType: 'text' });  }
  

  httpCommonPostService(Url,Payload):Observable<any>{
    return this.http.post(Url,Payload);
  }
  httpCommonGetService(Url): Observable<any> {
    return this.http.get(Url);
  }
  httpCommonDeleteService(Url): Observable<any> {
    return this.http.delete(Url);
  }
  httpPostServiceForContentTypeUrlencodedForCPW(Url, Payload): Observable<any> {
    let body = new URLSearchParams();
    body.set("oldpassword", Payload.oldPassword);
    body.set("newpassword", Payload.password);
    body.set("confirmpassword", Payload.confirmPassword);
    let _headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post(Url, body, { headers: _headers });

  }
  httpCommonTextPlainGetService(Url): Observable<any> {
    let _headers = new HttpHeaders({
      'Content-Type': 'text/plain'
    });
    return this.http.get(Url, { headers: _headers });
  }
  httpCommonPlainTextGetService(url: string) {
    return this.http.get(url, { responseType: 'text' });
  }

  httpfilePostService(Url,Payload):Observable<any>{
    const formData = new FormData();
    Object.keys(Payload).forEach(key => {
      formData.append(key, Payload[key]);
    });
    return this.http.post(Url, formData);
  }
  downloadTemplate(Url:string,webhookId:string,fileName: string,responseTemplate:boolean): Observable<Blob> {
    const queryParams = `?responseTemplate=${responseTemplate}`;
    return this.http.get(`${Url}/${webhookId}/${fileName}${queryParams}`, {
      responseType: 'blob'
    });
  }
  downloadFileTemplate(Url: string): Observable<Blob> {
    return this.http.get(`${Url}`, {
      responseType: 'blob'
    });
  }

  loadMenuCounts() {
  }
}
